module.exports = __webpack_public_path__ + "img/CNAS.4b574faa.png";